module.exports = __webpack_public_path__ + "img/index6.f40cf5db.png";